var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVehicleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2267 1.68001C20.96 0.893344 20.2133 0.333344 19.3333 0.333344H4.66667C3.78667 0.333344 3.05333 0.893344 2.77333 1.68001L0 9.66668V20.3333C0 21.0667 0.6 21.6667 1.33333 21.6667H2.66667C3.4 21.6667 4 21.0667 4 20.3333V19H20V20.3333C20 21.0667 20.6 21.6667 21.3333 21.6667H22.6667C23.4 21.6667 24 21.0667 24 20.3333V9.66668L21.2267 1.68001ZM4.66667 15C3.56 15 2.66667 14.1067 2.66667 13C2.66667 11.8933 3.56 11 4.66667 11C5.77333 11 6.66667 11.8933 6.66667 13C6.66667 14.1067 5.77333 15 4.66667 15ZM19.3333 15C18.2267 15 17.3333 14.1067 17.3333 13C17.3333 11.8933 18.2267 11 19.3333 11C20.44 11 21.3333 11.8933 21.3333 13C21.3333 14.1067 20.44 15 19.3333 15ZM2.66667 8.33334L4.66667 2.33334H19.3333L21.3333 8.33334H2.66667Z",
    fill: "#20A8E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicleIcon);
export default __webpack_public_path__ + "static/media/vehicle_icon.3e35022807be46a1f5d30c5ad6273e0c.svg";
export { ForwardRef as ReactComponent };